<template>
  <ul data-animate="list" class="page-finishings-list__list">
    <li v-for="finishing in finishings" :key="finishing.id">
      <div class="page-finishings-list__list__item">
        <PagesFinishingsListBlock :finishing="finishing" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesFinishingsList',
}
</script>

<script setup>
const props = defineProps({
  finishings: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
